module.exports = __webpack_public_path__ + "media/images/fallback/linkedin_email_social_icons-d1f6692c1bba41950af50d4189acc49d.png";